<template>
  <v-container justify-center >
    <v-card  class="card-top">
      <v-card-title class="subheading pa-2 ma-0 text-uppercase">
        Subscriptions
        <v-spacer />
        <v-btn @click="submit" small outline style="zoom:90%" color="indigo">Save</v-btn>&nbsp;
        <v-btn small icon @click="closeDialog">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs3 class="field text-xs-left">
            <strong>Choose Report</strong>
            <br />
            <v-autocomplete
              attach
              class="style-input mr-2 pt-1"
              item-text="name"
              outline
              single-line
              hide-details
              height="20px"
              item-value="id"
              v-model="report.report_id"
              :items="reports"
              v-on:change="setDetails(selected)"
            />
          </v-flex>
          <v-flex xs3 class="field text-xs-left" pl-2>
            <strong>Report Name</strong>
            <br />
            <v-text-field
              outline
              single-line
              hide-details
              height="20px"
              class="style-input mr-2 pt-1"
              v-model="report.name"
            />
          </v-flex>
          <v-flex xs2 pl-3 class="field text-xs-left">
            <strong>Export As</strong>
            <br />
            <v-autocomplete
              attach
              class="style-input mr-2 pt-1"
              item-text="name"
              outline
              single-line
              hide-details
              height="20px"
              item-value="id"
              v-model="report.export_options.file_type"
              :items="exportAs"
            />
          </v-flex>
          <v-flex xs2 pl-1 class="pa-0 ma-0">
            <v-switch label="Schedule my report " class="pa-1 mt-3 ma-0" style="zoom:90%" v-model="recurring" />
          </v-flex>
          <v-flex xs2 pl-1 class="pa-0 ma-0">
            <v-switch label="MultiSheet " class="pa-1 mt-3 ma-0" style="zoom:90%"  v-if="isMultiSheet" v-model="multiSheet"  v-on:change="handleEvent" />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs8 class="field text-xs-left">
            <strong>Send Email to</strong>
            <br />
            <v-text-field
              outline
              single-line
              hide-details
              height="20px"
              class="style-input mr-2 pt-1"
              v-model="report.email_to"             
            />
          </v-flex>
          <v-flex xs4 class="field text-xs-left" v-if="multiSheet">
            <strong>Group As</strong>
         
            <v-autocomplete
              attach
              class="style-input mr-2 pt-1"
              item-text="name"
              outline
              single-line
              hide-details
              height="20px"
              item-value="id"
              multiple
              chips
             small-chips
              v-model="report.group_options"
              :items="groupAs"
            />

          </v-flex>
        </v-layout>
        <v-layout row wrap pa-0 pt-3 v-if="recurring">
          <v-flex xs6>
            <v-layout row wrap>
              <!-- <v-flex xs3 class="field text-xs-left">
                 <strong>Schedule Date</strong>
            <br />
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="report.schedule_date"
                    outline
                    single-line
                    hide-details
                    height="30px"
                    append-icon="event"
                    readonly
                  />
                  <v-date-picker v-model="schedule_date_fmt" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>-->
              <v-flex xs3 class="field text-xs-left">
                <strong>Schedule Date</strong>
                <v-text-field
                  v-model="report.schedule_date"
                  single-line
                  class="pa-0 ma-0 pt-1"
                  outline
                  @change="checkingScheduleDate"
                  :error-messages="errorMessages.schedule_date"
                  placeholder="MM/DD/YYYY"
                />
              </v-flex>
              
              <v-flex xs3 md3 class="field text-xs-left" pl-2>
                <strong>Schedule Time</strong>
                <v-text-field
                  v-model="report.schedule_time"
                  single-line
                  class="pa-0 ma-0 pt-1"
                  outline
                  @change="checkingScheduleTime"
                  :error-messages="errorMessages.schedule_time"
                  placeholder="HH:mm"
                />
              </v-flex>
              <!-- <v-flex xs3 md3 class="field text-xs-left"  pl-2>
                 <strong>Schedule Time</strong>
            <br />
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu3"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    outline
                    single-line
                    hide-details
                    height="30px"
                    v-model="report.schedule_time"
                   append-icon="event"
                    readonly
                  />
                  <v-time-picker
                    v-model="report.schedule_time"
                    class="mt-3"
                    format="24hr"
                    scrollable
                  ></v-time-picker>
                </v-menu>
              </v-flex>-->
              <v-flex xs3 md3 pl-3 class="field text-xs-left">
                <strong>Interval</strong>
                <br />
                <v-text-field
                  outline
                  single-line
                  hide-details
                  height="30px"
                  class="pt-1"
                  v-model="report.schedule_interval"
                />
              </v-flex>
              <v-flex xs3 class="field text-xs-left" pl-2>
                <strong>Frequency</strong>
                <br />
                <v-autocomplete
                  attach
                  class="style-input mr-2 pt-1"
                  outline
                  single-line
                  hide-details
                  height="30px"
                  :items="scheduleTypes"
                  v-model="report.schedule_type"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6 class="pa-0 ma-0">
            <v-layout class="pa-0 ma-0 mt-3">
              <v-flex class="pa-0 ma-0">
                <v-checkbox  label="Sun" value="Sunday"  class="pa-0 ma-1" v-model="checkedDay" color="blue"></v-checkbox>
               
              </v-flex>
              <v-flex>
                <v-checkbox   class="pa-0 ma-1" label="Mon" value="Monday"  v-model="checkedDay" color="blue"></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox   class="pa-0 ma-1" label="Tue" value="Tuesday"  v-model="checkedDay" color="blue"></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox   class="pa-0 ma-1" label="Wed" value="Wednesday"  v-model="checkedDay" color="blue"></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox   label="Thu" class="pa-0 ma-1" value="Thursday"  v-model="checkedDay" color="blue"></v-checkbox>
              </v-flex>
              <v-checkbox   label="Fri" value="Friday"  v-model="checkedDay" class="pa-0 ma-1" color="blue"></v-checkbox>
              <v-flex>
                <v-checkbox   label="Sat" value="Saturday"  class="pa-0 ma-1" v-model="checkedDay" color="blue"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- <hr size="5px" class="blue blue--text lighten-3" /> -->
    <v-card class="card-top mt-2" v-if="report.report_id">
    <v-layout class="tibura-card" row wrap pa-0 ma-0>
    <v-flex xs4 md2 pa-0 ma-0  :style="styleHeight" style="border-right:1px solid #e2edbd">
      <v-list class="subheading body-2 lighten-4 settingsList">
        <v-list-tile :class="options.filter ? 'activeSettingList' :''" @click="showCard('filter')">
          <v-list-tile-title class="text-uppercase">  <v-icon small class="pr-1">fa-filter</v-icon>&nbsp;<b>Filter</b></v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="options.layout ? 'activeSettingList' :''"
          @click="showCard('layout')"
        >
          <v-list-tile-title  class="text-uppercase"> <v-icon small class="pr-1">fa fa-columns </v-icon>&nbsp;<b>Layout</b></v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="options.sort ? 'activeSettingList' :''"
          @click="showCard('sort')"
        >
          <v-list-tile-title  class="text-uppercase"> <v-icon small class="pr-1">fas fa-sort</v-icon> <b>Sorting</b></v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex xs8 md10 class="white" :style="styleHeight">
      <ReportFilter v-if="options.filter" :value="report.filters"  />
      <ReportLayout v-if="options.layout"  :value="report.columns" :layout="report.layout" v-on:layoutChanged="setLayout"/>
      <ReportSort v-if="options.sort" :value="report.columns" :sort="report.sort" v-on:sortChanged="setSort"/>
    </v-flex>
  </v-layout>
    </v-card>
    <!-- <v-tabs centered color="blue" dark dense small icons-and-text>
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab href="#tab-filters">
        Filters
        <v-icon>fa-filter</v-icon>
      </v-tab>

      <v-tab href="#tab-layout">
        Layout
        <v-icon>favorite</v-icon>
      </v-tab>

      <v-tab href="#tab-sort">
        Sorting
        <v-icon>fas fa-sort-amount-up-alt</v-icon>
      </v-tab>
      <v-tab-item key="filters" value="tab-filters">
        <ReportFilter :value="report.filters" />
      </v-tab-item>
      <v-tab-item key="layout" value="tab-layout">
        <ReportLayout
          :value="report.columns"
          :layout="report.layout"
          v-on:layoutChanged="setLayout"
        />
      </v-tab-item>
      <v-tab-item key="sort" value="tab-sort">
        <ReportSort :value="report.columns" :sort="report.sort" v-on:sortChanged="setSort" />
      </v-tab-item>
    </v-tabs> -->
  </v-container>
</template>
<script>
import moment from  'moment-timezone'
import ReportSort from "./ReportSort.vue";
import ReportFilter from "./ReportFilter.vue";
import ReportLayout from "./ReportLayout.vue";
import ReportModel from "../../service/ReportService";
import ReportSubscriptionModel from "../../service/ReportSubscriptionService";
import DropDownReport2 from '@/components/DropDownReport2.vue'

export default {
  components: {
    ReportFilter,
    ReportLayout,
    ReportSort,
    DropDownReport2

  },
  data() {
    return {
      layout: {},
      errorMessages: {},
      selectedReportId: 0,
      reports: [],
      recurring: false,
      multiSheet:false,
      isMultiSheet:false,
      schedule_date_fmt: "",
      schedule_time_fmt: "",
      menu3: false,
      menu2: false,
      scheduleTypes: ["hours", "days"],
      exportAs: ["Excel", "Pdf","Ppt",'json'],
      groupAs: ["season", "season_yr","prod_line_desc",'sbu_desc','comm_desc','lic_id','col_group_desc'],
      checkedDay:[],
      report: {
        report_id: 0,
        description: "",
        name: "",
        schedule_date: '',
        schedule_time: '',
        report_id: "",
        filters: {},
        columns: {},
        layout: [],
        sort: {},
        export_options: {
          file_type: "Excel"
        },
        group_options:[]
      },
      styleHeight: "min-height:" + (window.innerHeight - 120) + "px", 
        options:{
          filter:true,
          layout:false,
          sort:false
        }
    };
  },
  created: function() {
    //this.user= this.$store.authorizedUser
    //this.scheduleDateFmt=this.formatDate(this.scheduleDate)
    //this.scheduleDateTime= this.formatTime(this.scheduleDate)
    this.getReports();
    if (this.$route.query.id) {
      ReportSubscriptionModel.findOne({ id: this.$route.query.id })
        .then(response => {
          this.setReportSubscribe(response);
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      this.report.email_to = this.$store.getters.userInfo.email;
    }
  },
  watch: {
    schedule_date_fmt() {
      this.report.schedule_date = moment(this.schedule_date_fmt).format(
        "MM/DD/YYYY"
      );
      
      //alert('here')
      //alert(this.schedule_date_fmt)
    },
    schedule_time_fmt() {
      this.report.schedule_time = moment(this.schedule_time_fmt).format(
        "HH:mm"
      );
    }
  },
  methods: {
    moment,
     showCard($type) {
      this.options = {
        filter: false,
        layout: false,
        sort: false
      };
      this.options[$type] = true;
    },
    checkingScheduleDate() {
      var date = moment(this.report.schedule_date).format("MM/DD/YYYY");
      var now = moment().format("MM/DD/YYYY");
      if (now > date) {
        this.errorMessages.schedule_date = "Schedule Date < Today";
        // date is past
      } else {
        // date is future
        this.errorMessages.schedule_date = "";
      }
    },
    checkingScheduleTime() {
      var time = moment(this.report.schedule_time).utc().format("HH:mm");
      var now = moment().format("HH:mm");
      if (now > time) {
        this.errorMessages.schedule_time = "Schedule Time < Today";
        // date is past
      } else {
        // date is future
        this.errorMessages.schedule_time = "";
      }
    },
    setReportSubscribe($report) {
      this.report = $report[0];
      var $mailTo = JSON.parse(this.report.email_to).mail_to;
      this.report.email_to =
        $mailTo.length == 1 ? $mailTo[0] : $mailTo.length > 1 ? $mailTo : "";
      this.report.export_options = JSON.parse(this.report.export_options);
      this.report.filters = JSON.parse(this.report.filter_options);
      this.report.layout = JSON.parse(this.report.layout_options);
      this.report.columns = JSON.parse(this.report.reports.columns);
      this.report.sort = JSON.parse(this.report.sort_options);
       this.report.group_options = JSON.parse(this.report.group_options);
    let $keys = Object.keys(this.report.columns)
      for(let $i=0;$i<$keys.length;$i++) {
        if(this.report.layout.indexOf($keys[$i])>=0) {
          this.report.columns[$keys[$i]].visible=true
        } else {
          this.report.columns[$keys[$i]].visible=false
        }
        
      }
      if (JSON.parse(this.report.schedule_at).interval) {

        this.recurring = true;
      
        this.report.schedule_date = moment($report[0].next_date).format("MM/DD/YYYY");
        this.report.schedule_time = moment($report[0].next_date).format("HH:mm");
    
        // console.log(moment(this.report.schedule_time,'MM/DD/YYYY HH:mm').tz('America/New_York'),'hhhh2222')
        // console.log(this.report.schedule_time.toLocaleString(),"hhhhhh111");
        var $interval = JSON.parse(this.report.schedule_at).interval.split(" ");
        this.report.schedule_interval = $interval[0];
        this.report.schedule_type = $interval[1];
        this.checkedDay = JSON.parse(this.report.schedule_day);
      
       
      }
       if(this.report.group_options && this.report.group_options.length>0){
         this.multiSheet = true;
       }
       if(this.report.report_id==102 || this.report.report_id == 200 ){
        this.isMultiSheet = true;
       }
    },

    getReports() {
      ReportModel.getReportForCompany({})
        .then(response => {
          this.setReports(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    setReports($data) {
      this.reports = $data;
      this.selectedColumns = [];
    },
    setLayout($layout) {
      this.report.layout = $layout;
    },
    setSort($sort) {
      this.report.sort = $sort;
    },
    closeDialog() {
      this.$router.go(-1);
    },
    setDetails() {
      var $parent = this;
      ReportModel.getOne(this.report.report_id)
        .then(response => {
          this.setReportDetail(response[0]);
        })
        .catch(error => {
          console.log(error);
        });
    },
    setReportDetail($selectedReport) {
      this.report_id = $selectedReport.id;
      this.report.description = $selectedReport.description;
      this.report.name = $selectedReport.name; //this.reports[this.report_id].name
      this.report.report_id = $selectedReport.id;
      this.report.filters = JSON.parse($selectedReport.filters);
      this.report.layout = JSON.parse($selectedReport.layout);
      this.report.columns = JSON.parse($selectedReport.columns);
      this.report.sort = JSON.parse($selectedReport.sort);
      this.isMultiSheet =( $selectedReport.id==102 || $selectedReport.id==200) ? true: false;
    },
    handleEvent(){
    this.report.group_options =[]
   
    },
    
    submit() {
      var navigate = this.$router;
      //alert(this.report.schedule_date)
     /* let $nextDate = this.report.schedule_date
        ? new Date(this.report.schedule_date + " " + this.report.schedule_time)
        : moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD HH:mm:ss");
        */
           var $nextDate =  this.report.schedule_date+" "+ this.report.schedule_time 
          
        // // // $nextDate = moment($nextDate).tz('America/New_York').format('YYYY-MM-DD HH:mm')
            $nextDate = this.report.schedule_date ? moment($nextDate).tz('utc').format('YYYY-MM-DD HH:mm') : null
            
           //  $nextDate = this.report.schedule_date ? moment($nextDate).format('YYYY-MM-DD HH:mm') : null
          // let $nextDate = this.report.schedule_date ? moment(this.report.schedule_date + this.report.schedule_time ).format('YYYY-MM-DD HH:mm') : null
        //  console.log($nextDate,'zzzzzz')
      // alert($nextDate)

      let $emails = [];
      if (Array.isArray(this.report.email_to)) {
        $emails = this.report.email_to;
      } else if (typeof this.report.email_to === "string") {
        if (this.report.email_to.indexOf(";") > -1) {
          $emails = this.report.email_to.split(";");
        } else if (this.report.email_to.indexOf(",") > -1) {
          $emails = this.report.email_to.split(",");
        } else if (this.report.email_to.trim() !== "") {
          $emails = [this.report.email_to];
        }
      }
      $emails = $emails
        .map(email => (typeof email === "string" ? email.trim() : email))
        .filter(email => email);

      let $report = {
        report_id: this.report.report_id,
        name: this.report.name,
        schedule_at: JSON.stringify({
          interval: this.report.schedule_interval
            ? this.report.schedule_interval + " " + this.report.schedule_type
            : "",
          runAt: this.report.schedule_date ? this.report.schedule_date : ""
        }),
        next_date:$nextDate,  
        
        /*next_date: moment($nextDate, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD HH:mm:ss"
        )*/ //new Date(this.scheduleDate+" "+this.scheduleTime).toISOString().slice(0, 19).replace('T', ' '),
        email_to: JSON.stringify({
          mail_to: $emails
        }),
        schedule_day:  JSON.stringify(this.checkedDay)  ?JSON.stringify(this.checkedDay) : null,
        set_day : this.checkedDay ? true : false,
        filter_options: JSON.stringify(this.report.filters),
        sort_options: JSON.stringify(this.report.sort),
        layout_options: JSON.stringify(this.report.layout),
        export_options: JSON.stringify(this.report.export_options),
        active: 1,
        processing: 0,
        columns: JSON.stringify(this.report.columns),
        group_options: JSON.stringify(this.report.group_options),
      };
      if (this.report.id) {
        $report.id = this.report.id;
        ReportSubscriptionModel.save($report)
          .then(response => {
         navigate.push("/reportSubscriptions");
          })
          .catch(error => {
            console.log(error);
          });
      } else {
      
        ReportSubscriptionModel.create($report)
          .then(response => {
            navigate.push("/reportSubscriptions");
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
<style>
.activeSettingList, .activeSettingList .v-list__tile .v-list__tile__title .v-icon, .settingsList .v-list__tile:hover, .settingsList .v-list__tile:hover .v-icon{
  background-color: #2b2f8e !important;
  color: white !important;
  cursor:pointer;
}
.settingsList .v-list__tile .v-icon, .settingsList  {
  color: #2b2f8e !important;
  cursor:pointer;
}
</style>
